/**
 * contains the abi and contract address
*/

class GuildTagClassificationsContract {
    constructor() {
        this.abi =  [
	{
		"constant": false,
		"inputs": [
			{
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"internalType": "bytes32",
				"name": "hash",
				"type": "bytes32"
			}
		],
		"name": "newGuildClassification",
		"outputs": [],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "address",
				"name": "guildsAddress",
				"type": "address"
			}
		],
		"payable": false,
		"stateMutability": "nonpayable",
		"type": "constructor"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "uint32",
				"name": "guildId",
				"type": "uint32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "hash",
				"type": "bytes32"
			}
		],
		"name": "NewGuildClassification",
		"type": "event"
	}
        ];

        this.contractAddress = '0x3831959eF022C226F3bdfF6481f4666901428f90';

    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default GuildTagClassificationsContract;

